import React from "react";
import PropTypes from "prop-types";
import Button from "../../../Elements/Button/Button.js";
import Image from "../../../Elements/Image/Image.tsx";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import Icon from "../../../Elements/Icon/Icon.tsx";

const Splashscreen = ({ tourName, handleStart, handleSkip }) => {
  const { getTextByKey, getHtmlByKey } = useContent();

  return (
    <div className="product-tour-overlay">
      <div className="tour-splash">
        {tourName === "page-edit" || tourName === "create-form" ? (
          <div className="editpages-logo">
            <div className="logo-div">
              <Icon name={"jform-black"} />
            </div>{" "}
            <h1>JUMBOforms</h1>
          </div>
        ) : (
          <div className="logo">
            <Image name={"jumbomail-logo-small"} />
            <h1>JUMBOmail</h1>
          </div>
        )}
        <h2>{getTextByKey(`0_tour_${tourName}_title`)}</h2>
        <p>{getHtmlByKey(`0_tour_${tourName}_text`)}</p>
        <div className="control-buttons">
          <Button
            title={getTextByKey("welcome_tour_start")}
            onClick={handleStart}
            buttonClass="take-a-tour"
          />
          <a onClick={handleSkip} className="skip-a-tour">
            {getTextByKey("welcome_tour_skip")}
          </a>
        </div>
      </div>
    </div>
  );
};

Splashscreen.propTypes = {
  tourName: PropTypes.string.isRequired,
  handleStart: PropTypes.func.isRequired,
  handleSkip: PropTypes.func.isRequired,
};

export default Splashscreen;
